
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/collections/[slug]",
      function () {
        return require("private-next-pages/[locale]/collections/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/collections/[slug]"])
      });
    }
  